export {
  faAngleDown,
  faArrowDownAZ,
  faArrowLeft,
  faArrowRight,
  faArrowsRotate,
  faArrowToLeft,
  faArrowToRight,
  faArrowsLeftRight,
  faArrowUp,
  faBan,
  faBars,
  faBell,
  faBolt,
  faBellOn,
  faBellPlus,
  faBox,
  faBuilding,
  faBuildingMemo,
  faBullseyeArrow,
  faCalculator,
  faCar,
  faCarBurst,
  faCaretDown,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronsLeft,
  faChevronsRight,
  faChevronUp,
  faCircle,
  faCircleSmall,
  faCircleExclamation,
  faCirclePlay,
  faCircleXmark,
  faClipboardCheck,
  faClipboardList,
  faClipboardListCheck,
  faClipboardQuestion,
  faClockRotateLeft,
  faCode,
  faCog,
  faCoins,
  faCube,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faEnvelopeDot,
  faEraser,
  faEuroSign,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLink,
  faDialpad,
  faFile,
  faFileContract,
  faFileExcel,
  faFilePdf,
  faFileCirclePlus,
  faFilter,
  faFileSignature,
  faFileWord,
  faFiles,
  faFlag,
  faFlagCheckered,
  faFloppyDiskPen,
  faFolderOpen,
  faGears,
  faGrid,
  faHandPointLeft,
  faHome,
  faHomeLgAlt,
  faHouseWindow,
  faInfoCircle,
  faLink,
  faList,
  faLock,
  faMapMarkerAlt,
  faMemo,
  faMemoCircleCheck,
  faMoneyCheckDollarPen,
  faNetworkWired,
  faNoteSticky,
  faNotes,
  faPaperclip,
  faPaperPlane,
  faPaperPlaneTop,
  faPercent,
  faPen,
  faPhoneVolume,
  faPlayCircle,
  faPlus,
  faQuestionCircle,
  faReceipt,
  faRecycle,
  faRedo,
  faRedoAlt,
  faRectangleHistoryCircleUser,
  faRobot,
  faRotateLeft,
  faRotateRight,
  faRuler,
  faSave,
  faScaleUnbalanced,
  faShoppingCart,
  faSignature,
  faSparkles,
  faSquareCode,
  faSquarePlus,
  faStar,
  faTable,
  faTableList,
  faThumbsUp,
  faTimes,
  faTimeline,
  faToolbox,
  faTools,
  faTrash,
  faUnlock,
  faUnlockAlt,
  faUser,
  faUserGroup,
  faUserCheck,
  faUserHeadset,
  faUserPlus,
  faUserSecret,
  faUserTie,
  faUsers,
  faWrench,
  faXmark,
  faListCheck,
  faStickyNote,
  faFileAlt,
  faFileArrowUp,
  faShieldCheck,
  faGlasses,
  faComment,
} from '@fortawesome/pro-solid-svg-icons';
